import { message } from 'antd'
import type { ApiError } from '../types'

/**
 * 处理 API 错误响应
 */
export const handleApiError = (error: unknown, context: string = '操作失败'): void => {
  console.error(`[${context}]`, error)

  if (error instanceof Error) {
    // 网络错误
    if (error.message.includes('Failed to fetch') || error.message.includes('NetworkError')) {
      message.error('网络连接失败，请检查网络后重试')
      return
    }

    // 解析 API 错误响应
    try {
      const apiError = JSON.parse(error.message) as ApiError
      handleApiErrorCode(apiError.code, apiError.message)
      return
    } catch {
      // 不是 JSON 格式，使用默认消息
    }

    message.error(`${context}: ${error.message}`)
    return
  }

  message.error(context)
}

/**
 * 根据错误码显示具体错误信息
 */
const handleApiErrorCode = (code: string, defaultMessage: string): void => {
  // 使用错误码映射或默认消息
  const errorMsg = code ? `${code}: ${defaultMessage}` : defaultMessage
  message.error(errorMsg)
}

/**
 * 检查响应状态
 */
export const checkResponseStatus = (response: Response): void => {
  if (!response.ok) {
    throw new Error(`HTTP ${response.status}: ${response.statusText}`)
  }
}

/**
 * 安全解析 JSON 响应
 */
export const safeParseJson = async <T>(response: Response): Promise<T> => {
  const text = await response.text()
  try {
    return JSON.parse(text) as T
  } catch {
    throw new Error(`Invalid JSON response: ${text.slice(0, 100)}`)
  }
}
